var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meta-referral-list" }, [
    _c("div", { staticClass: "meta-referral-header" }, [
      _c("h3", [_vm._v(_vm._s(_vm.$t("auto.adInteractions")))]),
      _vm._v(" "),
      _c("div", { staticClass: "meta-referral-filter" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchQuery,
              expression: "searchQuery",
            },
          ],
          attrs: { type: "text", placeholder: _vm.$t("auto.searchAd") },
          domProps: { value: _vm.searchQuery },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchQuery = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filterStatus,
                expression: "filterStatus",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.filterStatus = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v(_vm._s(_vm.$t("auto.allStatuses"))),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ACTIVE" } }, [
              _vm._v(_vm._s(_vm.$t("auto.active"))),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "CAMPAIGN_PAUSED" } }, [
              _vm._v(_vm._s(_vm.$t("auto.campaignPaused"))),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "PAUSED" } }, [
              _vm._v(_vm._s(_vm.$t("auto.paused"))),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ARCHIVED" } }, [
              _vm._v(_vm._s(_vm.$t("auto.archived"))),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.filteredReferrals.length === 0
      ? _c("div", { staticClass: "empty-container" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" "),
          _vm.searchQuery || _vm.filterStatus
            ? _c("p", [
                _vm._v(_vm._s(_vm.$t("auto.noAdInteractionMatchingCriteria"))),
              ])
            : _c("p", [_vm._v(_vm._s(_vm.$t("auto.noAdInteractionYet")))]),
        ])
      : _c(
          "div",
          { staticClass: "referrals-container" },
          _vm._l(_vm.filteredReferrals, function (referral) {
            return _c(
              "div",
              { key: referral._id, staticClass: "referral-card" },
              [
                _c("div", { staticClass: "referral-header" }, [
                  _c("div", { staticClass: "referral-title" }, [
                    _c("span", { staticClass: "date-badge" }, [
                      _vm._v(_vm._s(_vm.formatDate(referral.createdAt))),
                    ]),
                    _vm._v(" "),
                    referral.headline
                      ? _c("h4", [_vm._v(_vm._s(referral.headline))])
                      : _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("message.metaAdDefaultHeadline"))
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "referral-badges" }, [
                    _c(
                      "span",
                      {
                        staticClass: "source-badge",
                        class: referral.sourceType,
                      },
                      [_vm._v(_vm._s(referral.sourceType))]
                    ),
                    _vm._v(" "),
                    referral.adInfo && referral.adInfo.effective_status
                      ? _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: _vm.getStatusClass(
                              referral.adInfo.effective_status
                            ),
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getStatusText(
                                    referral.adInfo.effective_status
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "referral-body" }, [
                  referral.body
                    ? _c("p", [_vm._v(_vm._s(referral.body))])
                    : _vm._e(),
                  _vm._v(" "),
                  referral.adInfo
                    ? _c("div", { staticClass: "ad-details" }, [
                        _c("div", { staticClass: "detail-item" }, [
                          _c("div", { staticClass: "detail-label" }, [
                            _c("i", { staticClass: "fas fa-ad" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("auto.ad")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" },
                              ],
                              staticClass: "detail-value",
                              attrs: { title: referral.adInfo.name || "-" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(referral.adInfo.name || "-") +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-item" }, [
                          _c("div", { staticClass: "detail-label" }, [
                            _c("i", { staticClass: "fas fa-layer-group" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("auto.adSet")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" },
                              ],
                              staticClass: "detail-value",
                              attrs: { title: _vm.getAdSetName(referral) },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getAdSetName(referral)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-item" }, [
                          _c("div", { staticClass: "detail-label" }, [
                            _c("i", { staticClass: "fas fa-bullhorn" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("auto.campaign")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" },
                              ],
                              staticClass: "detail-value",
                              attrs: { title: _vm.getCampaignName(referral) },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getCampaignName(referral)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        referral.adInfo.account_id
                          ? _c("div", { staticClass: "detail-item" }, [
                              _c("div", { staticClass: "detail-label" }, [
                                _c("i", { staticClass: "fas fa-user-circle" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("auto.accountId")) + ":"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-value" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(referral.adInfo.account_id) +
                                    "\n                        "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                referral.sourceLink
                  ? _c("div", { staticClass: "referral-footer" }, [
                      _c(
                        "a",
                        {
                          staticClass: "view-link",
                          attrs: {
                            href: referral.sourceLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-external-link-alt" }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("auto.viewAd")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }